export default "<div id=\"point\" class=\"points\">+{{ points }} Points</div>\n"